<template>
  <aftership-aedd
    app-name="aftership"
    app-platform="shopify"
    class="aftership-container"
    description="Estimated delivery"
    text-color="#232933"
    icon-color="#5C5F62"
    background-color="#FFFFFF"
    top-padding="28"
    bottom-padding="28"
    app-key="lyleandscott-development.myshopify.com"
    :product-id="product.id"
  />
</template>

<script>

/**
 * Vue: Aftership (aftership)
 * -----------------------------------------------------------------------------
 * Aftership widget.
 *
 * @param {Object} product - Product data.
 */
export default {
  name: 'Aftership',

  props: {
    product: {
      type: [Object, Boolean],
      default: false,
    },
    customElement: {
      type: String,
      default: '',
    },
  },

  watch: {

    product: {
      deep: true,
      handler(newValue) {
        this.updateAsProduct(newValue)
      },
    },
  },

  mounted() {
    this.updateAsProduct(this.product)
  },

  methods: {

    /**
     * Update product data json.
     * @param {Object|Boolean} product
     */
    updateAsProduct(product) {
      const scriptElement = document.querySelector('#asProductScript')

      if (scriptElement && product) {
        scriptElement.innerHTML = `window._asProduct = ${JSON.stringify(product)}`
      }
    },
  },
}
</script>
